import * as Darby from './darby_alerts';
import DataTable from 'datatables.net-bs5';

/*** Events ***/

(function() {

  let $rsvpModal = $('#rsvp');
  let $changeRoleModal = $('#change-role');

  function setButtonRole($entityButton, role) {
    //console.log('setButtonRole');
    if (role == ''){
      role = $entityButton.hasClass('badge-primary') ? 'Participant' :
        $entityButton.hasClass('badge-success') ? 'Absent' :
          $entityButton.hasClass('badge-light') ? 'Interested' :
            $entityButton.hasClass('badge-secondary') ? 'Attendant' :
              $entityButton.hasClass('badge-dark') ? 'Excluded' :
                $entityButton.hasClass('badge-danger') ? 'Manager' :
                    $entityButton.hasClass('badge-info') ? 'Staff' : '';
    }
    $entityButton.removeClass('badge-primary');
    $entityButton.removeClass('badge-success');
    $entityButton.removeClass('badge-light');
    $entityButton.removeClass('badge-secondary');
    $entityButton.removeClass('badge-info');
    $entityButton.removeClass('badge-danger');
    $entityButton.removeClass('badge-warning');
    $entityButton.removeClass('badge-dark');
    switch (role) {
      case 'Attendant':
        $entityButton.addClass('badge-primary');
        break;
      case 'Participant':
        $entityButton.addClass('badge-success');
        break;
      case 'Absent':
        $entityButton.addClass('badge-light');
        break;
      case 'Interested':
        $entityButton.addClass('badge-secondary');
        break;
      case 'Excluded':
        $entityButton.addClass('badge-dark');
        break;
      case 'Manager':
        $entityButton.addClass('badge-danger');
        break;
      case 'Staff':
        $entityButton.addClass('badge-info');
        break;
      default:
        $entityButton.addClass('badge-light');
    }
    $entityButton.data('current_entity_role', role);
    //if ($.inArray($entityButton.text(), ['Attendant', 'Participant', 'Absent', 'Interested', 'Invited']) != -1){
      $entityButton.filter('.role_button').text(role)
    //}
  }

  function changeRole(event){
    //console.log('changeRole');
    const $selectedRole = $(this);
    const entityEvent_id = $changeRoleModal.data('entity_event_id');
    const entityRole = $selectedRole.val();
    $changeRoleModal.modal('hide');
    let $entityButton = $('#attendees button[data-entity_event_id = ' + entityEvent_id + ']');
    setButtonRole($entityButton, entityRole) /* no role goes to next role. Do quick change while waiting for Echo event */
    const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: '/entityEvents/changeRole',
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          entityEvent_id: entityEvent_id,
          entity_role: entityRole,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          //console.log('changeRole success');
          // $('#attendees').html(data.html);
          // let $entityButton = $('#attendees button[data-entity_event_id = ' + data.entityEvent.id + ']');
          // setButtonRole($entityButton, data.entityEvent.entity_role);
          let entitiesCount = $('#attendees [name = "entities_count"]');
          entitiesCount.html(data.entities_count);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    );
  }

  function changeTicketStatus(cell, dt_tables_api) {
    event.preventDefault();
    let cellNode = cell.node();
    let ticket_id = $(cellNode).data('ticket_id');
    let ticketStatusUrl = '/tickets/used';
    if (cell.data().indexOf('Unused') >= 0){
      cell.data("<strong>USED</strong>").draw();
    } else {
      ticketStatusUrl = '/tickets/unused'
      cell.data("Unused").draw();
    }
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    $.ajax(
      {
        /* the route pointing to the post function */
        url: ticketStatusUrl,
        type: 'POST',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          ticket_id: ticket_id,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function (data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.status == 'error') {
            Darby.alertModal(data.message);
          } else {
            cell.data(data.html).draw();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          Darby.alertModal('Code Problem with changeTicketStatus');
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    ); // END AJAX
  }

  function swapTicketSpots(event) {
    event.stopPropagation();
    $(this).hasClass('spot-selected') ? $(this).removeClass('spot-selected') : $(this).addClass('spot-selected');
    let $spotsSelected = $('.spot-selected');
    if ($spotsSelected.length === 2) {
      let product_id_1 = $spotsSelected.first().attr('data-product_id');
      let round_1 = $spotsSelected.first().attr('data-round');
      let spot_id_1 = $spotsSelected.first().attr('data-spot_id');
      let spot_time_1 = $spotsSelected.first().attr('data-spot_time');
      let product_id_2 = $spotsSelected.last().attr('data-product_id');
      let round_2 = $spotsSelected.last().attr('data-round');
      let spot_id_2 = $spotsSelected.last().attr('data-spot_id');
      let spot_time_2 = $spotsSelected.last().attr('data-spot_time');
      let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
      $.ajax(
        {
          /* the route pointing to the post function */
          url: '/products/swap_spots',
          type: 'POST',
          /* send the csrf-token and the input to the controller */
          data: {
            _token: CSRF_TOKEN,
            product_id_1: product_id_1,
            round_1: round_1,
            spot_id_1: spot_id_1,
            spot_time_1: spot_time_1,
            product_id_2: product_id_2,
            round_2: round_2,
            spot_id_2: spot_id_2,
            spot_time_2: spot_time_2,
          },
          dataType: 'json',
          /* remind that 'data' is the response of the AjaxController */
          success: function (data, textStatus, jqXHR) {
            //console.log(jqXHR);
            if (data.status == 'error') {
              Darby.alertModal(data.message);
            } else {
              $('.spots[data-product_id="' + product_id_1 + '"]').each(getSeatingChart);
            }
          },
          error: function (jqXHR, textStatus, errorThrown) {
            window.location.href = "/login";
            console.log(textStatus);
            console.log(errorThrown);
          }
        }
      ); // END AJAX
    }
  }

  function showChangeRoleModal()
  {
    const $selectedButton = $(this);
    //console.log('showChangeRoleModal for entityEvent '+$selectedButton.data('entity_event_id'));
    $($changeRoleModal).data('entity_event_id', $selectedButton.data('entity_event_id'));
    $($changeRoleModal).find('h5').text($selectedButton.text());
    setButtonRole($('#change-role .send'), 'Attendant');
    if ($selectedButton.data('current_entity_role') != '') {
      setButtonRole($('#change-role [name=' + $selectedButton.data('current_entity_role') + ']'), 'Participant');
    }
    Darby.showModal($changeRoleModal);
  }

  function showRsvpModal()
  {
    const $selectedButton = $(this);
    const currentRole = $selectedButton.data('current_entity_role');
    // The same choices as the app's RsvpButtons: Maybe until the event starts, Participate
    // once it has, and no Skip for a Participant or anyone who has played a round. For both,
    // Attend reads Sit Out.
    const isActive = $selectedButton.data('active') == 1;
    const hasPlayed = $selectedButton.data('played') == 1;
    $($rsvpModal).data('event_id', $selectedButton.data('event_id'));
    $('#rsvp [name=Interested]').toggle(!isActive);
    $('#rsvp [name=Participant]').toggle(isActive);
    $('#rsvp [name=Attendant]').text(currentRole === 'Participant' || hasPlayed ? 'Sit Out' : 'Attend');
    $('#rsvp [name=Absent]').toggle(currentRole !== 'Participant' && !hasPlayed);
    setButtonRole($('#rsvp .send'), 'Attendant');
    if (currentRole != '') {
      setButtonRole($('#rsvp [name=' + currentRole + ']'), 'Participant');
    }
    Darby.showModal($rsvpModal);
  }

  function setRsvp()
  {
    const $selectedButton = $(this);
    let roleUrl = '';
    //alert($selectedButton.val() + " " + $rsvpModal.data('event_id'));
    switch ($selectedButton.val()) {
      case 'Participant':
        roleUrl = '/events/'+ $rsvpModal.data('event_id') + '/participate';
        break;
      case 'Attendant':
        roleUrl = '/events/'+ $rsvpModal.data('event_id') + '/attend';
        break;
      case 'Absent':
        roleUrl = '/events/'+ $rsvpModal.data('event_id') + '/unattend';
        break;
      case 'Interested':
        roleUrl = '/events/'+ $rsvpModal.data('event_id') + '/maybe';
        break;
      default:
        roleUrl = '/events/'+ $rsvpModal.data('event_id') + '/maybe';
    }
    $rsvpModal.modal('hide');
    let $rsvp = $('.rsvp[data-event_id = "' + $rsvpModal.data('event_id') + '"]'+'[data-entity_id = "' + $rsvpModal.data('entity_id') + '"]');
    if ($rsvp.length > 0) {
      $rsvp.data('current_entity_role', $selectedButton.val());
      $rsvp.text('RSVP - ' + $selectedButton.val());
    }
    const CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    const authData = { _token: CSRF_TOKEN };
    const authUser = $('meta[name="auth-user"]').attr('content');
    const authCode = $('meta[name="auth-code"]').attr('content');
    if (authUser && authCode) {
      authData.user = authUser;
      authData.code = authCode;
    }
    $.ajax(
      {
        /* the route pointing to the post function */
        url: roleUrl,
        method: 'GET',
        /* send the csrf-token and the input to the controller */
        data: authData,
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function ( data, textStatus, jqXHR) {
          Darby.alertModal(data.text);
          if (data.redirect && data.redirect.length > 0) {
            setTimeout(function() {window.location.replace(data.redirect);}, 1500);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (jqXHR.status === 401 || jqXHR.status === 403) {
            window.location.replace('/login');
          } else {
            console.log(textStatus);
            console.log(errorThrown);
            Darby.alertModal('Sorry, there was a problem setting your RSVP');
          }
        }
      }
    );

  }

  function getSeatingChart() {
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    let product_id = $(this).data('product_id');
    let entity_id = $(this).data('entity_id');
    let rounds = $(this).data('rounds');
    let seats_list = $(this).data('seats_list');
    let scoresUrl = '/products/'+ product_id + '/seatingChart';
    $.ajax(
      {
        /* the route pointing to the post function */
        url: scoresUrl,
        type: 'GET',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          entity_id: entity_id,
          rounds: rounds,
          seats_list: seats_list,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function (data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.status == 'error') {
            // Darby.alertModal(data.message);
            console.log(data.message);
          } else {
            $('.spots[data-product_id="'+product_id+'"][data-entity_id="'+entity_id+'"][data-rounds="'+rounds+'"][data-seats_list="'+seats_list+'"]').html(data.html);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // Darby.alertModal('Code Problem');
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    ); // END AJAX
  }

  function getScores(event_id, portion) {
    let CSRF_TOKEN = $('meta[name="csrf-token"]').attr('content');
    let scoresUrl = '/events/'+ event_id + '/scores';
    $.ajax(
      {
        /* the route pointing to the post function */
        url: scoresUrl,
        type: 'GET',
        /* send the csrf-token and the input to the controller */
        data: {
          _token: CSRF_TOKEN,
          portion: portion,
        },
        dataType: 'json',
        /* remind that 'data' is the response of the AjaxController */
        success: function (data, textStatus, jqXHR) {
          //console.log(jqXHR);
          if (data.status == 'error') {
            // Darby.alertModal(data.message);
            console.log(data.message);
          } else {
            $('.current-seating-chart').html(data.html);
            $('.full-seating-chart').html(data.full_html);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          // Darby.alertModal('Code Problem');
          console.log(textStatus);
          console.log(errorThrown);
        }
      }
    ); // END AJAX
  }

  function startWatch() {
    let $watchButton = $(this);
    // startTime, endTime, intervalSeconds, warningSeconds, stopSeconds
    // ("2024-01-12T20:10:00", "2024-01-13T17:00:00", 120, 60, 30)
    Darby.stopWatch($watchButton.attr('data-start_time'), $watchButton.attr('data-end_time'), $watchButton.attr('data-interval'), $watchButton.attr('data-warning'), $watchButton.attr('data-stop'));
  }

  function resetWatch() {
    console.log('resetWatch')
    let $resetButton = $(this);
    let $watchButton = $('.ds-stopwatch button.ds-watch');
    Darby.resetWatch($resetButton, $watchButton);
  }

  // Events
  // ======

  $('.ds-stopwatch').on('click', 'button.ds-watch', startWatch);
  $('.ds-stopwatch').on('click', 'button.ds-reset-watch', resetWatch);
  //$(document).on('click', '.change-role', changeRole);
  $('#event_results').on('click', ' .change-role', showChangeRoleModal);
  $('.change-role').on('click', showChangeRoleModal);
  $('#change-role .send').on('click', changeRole);
  $('.spots').on('click', '.spot', swapTicketSpots);
  // After a change made on this page (e.g. the transfer dialog), without waiting on Pusher.
  $(document).on('spots:refresh', function() {
    $('.spots').each(getSeatingChart);
  });
  // $('.ticket-table').on('click', '.ticket-status', changeTicketStatus);
  //let dt_tables_api = new DataTable('.dt_ticket_table');
  //dt_tables_api.on('click', 'td.dt-ticket-status', changeTicketStatus);
  //$('#ticket_results').on('click', 'td.dt-ticket-status', changeTicketStatus);
  $('#event_results').on('click', ' .rsvp', showRsvpModal);
  $('.rsvp').on('click', showRsvpModal);
  $('#rsvp .send').on('click', setRsvp);

  $('.dt_ticket_table').each(function() {
    let currentTable = $(this).DataTable();
    currentTable.on('click', 'td.dt-ticket-status', function() {
      let cell = currentTable.cell(this);
      changeTicketStatus(cell, currentTable);
    });
  });
  //$('#ticket_results').on('click', 'td.dt-ticket-status', changeTicketStatus);

  // Set up notifications
  function getHostName(url) {
    var a = document.createElement('a');
    a.href = url;
    var host = a.hostname.toLowerCase();
    a = null; // Explicitly remove reference to the element
    return host;
  }

  // Logic to refresh page if browser was offline due to sleep or something.
  let lastRefreshTime = 0;
  const refreshInterval = 5000; // 5 seconds in milliseconds

  function refreshData() {
    const currentTime = Date.now();
    if (currentTime - lastRefreshTime > refreshInterval) {
      console.log('Refreshing data...');
      lastRefreshTime = currentTime;
      // Commands that need to be refreshed
      $('.spots').each(getSeatingChart);

    } else {
      console.log('Refresh skipped, within interval.');
    }
  }

  refreshData();
  window.addEventListener('online', refreshData);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible' && navigator.onLine) {
      refreshData();
    }
  });


  window.Echo.channel('darby-events')
    .listen('UpdateSpotScores', updateSpotScores => {
      if (getHostName(updateSpotScores.app_url) === getHostName($(location).attr('host'))) {
        //console.log('updateSpotScores notice for event received.');
        //console.log(updateSpotScores);
        $('.spots').each(getSeatingChart);
      }
    })
    .listen('ChangeRole', changeRole => {
      if (getHostName(changeRole.app_url) === getHostName($(location).attr('host'))) {
        //console.log('ChangeRole notice for event received.');
        // console.log(changeRole);
        let $attendees = $('#attendees[data-event_id = ' + changeRole.entity_event.event_id + ']');
        if ($attendees.length > 0) {
          let $entityButton = $('#attendees button[data-entity_event_id = ' + changeRole.entity_event.id + ']');
          setButtonRole($entityButton, changeRole.entity_event.entity_role);
          $entityButton.data('current_entity_role', changeRole.entity_event.entity_role);
          let $entitiesCount = $('#attendees [name = "entities_count"]');
          $entitiesCount.html(changeRole.entities_count);
        }
        //console.log(changeRole);
        let $rsvp = $('.rsvp[data-event_id = "' + changeRole.entity_event.event_id + '"]'+'[data-entity_id = "' + changeRole.entity_event.entity_id + '"]');
        if ($rsvp.length > 0) {
          $rsvp.data('current_entity_role', changeRole.entity_event.entity_role);
          $rsvp.text('RSVP - ' + changeRole.entity_event.entity_role);
        }
      }
    })
    .listen('UpdateMessages', updateMessages => {
      if (getHostName(updateMessages.app_url) === getHostName($(location).attr('host'))) {
        //console.log('UpdateMessages notice for event received.');
        //console.log(updateMessages);
        $(".search[data-model='comments']").data('page', 1)
          .trigger('keyup');
      }
    })
  ;

})();
